"use client";
import React from "react";
import TapBookmark from "@/components/bookmark/TapBookmark";

export default function BookmarkInToolBtn({ tool, size = 28 }) {
  return <TapBookmark size={size} tool={tool} />;
}
